import React from "react";

export const LineSeparator = (props) => {
    return (
        <div className={`line-separator ${props.className}`}/>
    );
}
